var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpGreenLightGreenBgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#D2F9D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.65884 9.36553C6.86072 9.55394 7.17711 9.54303 7.36553 9.34116C8.02998 8.63144 8.72661 7.92143 9.5 7.32855V13.5C9.5 13.7761 9.72386 14 10 14C10.2761 14 10.5 13.7757 10.5 13.4996V7.32855C11.2737 7.9217 11.9686 8.62994 12.6345 9.34116C12.8229 9.54303 13.1393 9.55394 13.3412 9.36553C13.543 9.17711 13.5539 8.86064 13.3655 8.65876C12.6437 7.88584 11.898 7.12665 11.05 6.49062C10.7526 6.2676 10.3889 6 10 6C9.61106 6 9.24737 6.2676 8.95 6.49062C8.10706 7.12283 7.35388 7.89275 6.63447 8.65884C6.44606 8.86072 6.45697 9.17711 6.65884 9.36553Z",
    fill: "#006608"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpGreenLightGreenBgCircle);
export default __webpack_public_path__ + "static/media/arrowUpGreenLightGreenBgCircle.a3f4a67eae0cf1a00d3cb9a214d42851.svg";
export { ForwardRef as ReactComponent };